<template>
    <div class="card-container" :style="customStyle" @click="$emit('toggle')">
        <img class="card-container--img" src="~@/assets/images/logos/plus.svg" alt="">
        <div class="card-container--text-container">
            <p class="card-container--text-container--text1">{{$t('GIFTING_REMINDERS_ADD_A_NEW_DATE')}}</p>
            <p class="card-container--text-container--text2">{{$t('GIFTING_REMINDERS_EVENT_NAME')}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddGiftingRemindersCard',
    props: {
        customStyle: {
            type: Object,
        },
    },
};
</script>

<style lang="scss" scoped>
    .card-container {
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 0px 34px;
        min-width: 327px;
        min-height: 101px;
        border-radius: 3px;
        border: 1px dotted #CECECE;
        cursor: pointer;

        &--img {
            height: 40px;
            width: 40px;
        }
        &--text-container {
            margin-left: 13px;

            &--text1 {
                font-weight: 400;
                font-size: 18px;
                line-height: 21px;
                color: #868686;
            }
            &--text2 {
                font-weight: 300;
                font-size: 16px;
                line-height: 19.2px;
                color: #868686;
            }
        }
    }

    @media (min-width: 1024px){
        .card-container {
            min-width: 352px;
            min-height: 120px;
            justify-content: center;
        }
    }
</style>
